var testAB = {
	nameCookie: 'testAB',
	table: [],
	getTable: function () {
		this.table = [];
		var tmp = $.cookie(this.nameCookie);
		if (tmp !== undefined && tmp != '') {
			tmp = tmp.indexOf('::') > -1 ? tmp.split('::') : tmp.split('|');
			var that = this;
			$(tmp).each(function (i, n) {
				var t = n.split(':');
				n0 = '_' + t[0];
				n1 = t[1];
				that.table.push(n0);
				that.table[n0] = n1;
			});
		};
	},
	activeList: function (list) { // wywoływane z kodu EUro z listą aktywnch testów, hotfix: [dev] Usuwanie przestarzałych testów AB
		this.getTable();
		this.table.forEach(element => {
			const name = element.substr(1);
			if (!list.includes(name)) {
				this.delVar(name);
			}
		});
	},
	setTest: function (params = {}) {	// jest możliwość przypisania testów z dostarczonej funkcji, pomijamy tym samym obiekt Eurowy
		if (params.atrOff && $.cookie('atrUser') == 'js') {
			return false
		}
		if (params.name && this.getVar(params.name) === null) {
			var rand = Math.random() * 100;
			var name = params.name;
			var A = params.wariant.A.weight || 0;
			var B = params.wariant.B.weight || 0;
			var V = params.wariant.V.weight || 0;
			let result = 'V';
			if (rand > 0 && rand <= A) {
				result = 'A';
			} else if (rand > A && rand <= A + B) {
				result = 'B';
			}
			console.log('TestAB "' + name + '": los = ' + rand + ', A = 0-' + A + ', B = ' + A + '-' + (A + B) + ', V = ' + (A + B) + '-100, ustawiono: ' + result);
			this.setVar(name, result);
		}
	},
	setVar: function (name, value) {
		if (name && value) {
			console.log('Ustawiamy test AB: ' + name);
		}
		this.getTable();
		if (typeof this.table['_' + name] == "undefined") this.table.push('_' + name);
		this.table['_' + name] = value;
		this.synchronize();
	},
	getVar: function (name) {
		if (!this.table.length) this.getTable();
		if (typeof this.table['_' + name] == "undefined") return null;
		else return this.table['_' + name];
	},
	delVar: function (name) {
		console.log('Usuwany nieaktywny test AB: ' + name);
		this.setVar(name, null);
	},
	synchronize: function () {
		var cookie = '';
		var that = this;
		$(this.table).each(function (i, n) {
			var value = that.table[n];
			var key = n.substr(1);
			if (value != null) cookie += key + ':' + value + '::';
		});
		if (cookie.length > 0) cookie = cookie.substr(0, cookie.length - 2);
		$.cookie(this.nameCookie, cookie, { path: '/', expires: 365 });
	}
};
